import { useState } from "react";
import { Card, Grid } from "@mui/material";
import { getGraphObject } from "./functions/getGraphObject";
import DashboardLayout from "../../../../components/LayoutContainers/DashboardLayout";
import MDBox from "../../../../components/MDs/MDBox";
import Filter from "./components/filter";
import ImgGraph from "./components/imgGraph";

function Charts() {
  const [graphs, setGraphs] = useState([]);
  const [filterData, setFilterData] = useState({
    ip: "",
    domain: "",
    item: ""
  });

  const handleGraphChange = (value) => {
    const tempGraph = getGraphObject(value);
    setGraphs([...tempGraph]);
  };

  return (
    <DashboardLayout>

      <MDBox py={1}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12}>
            <Card sx={{ height: "100%", py: 4, px: 2 }}>
              <Filter
                filterData={filterData}
                setFilterData={setFilterData}
                handleGraphChange={handleGraphChange}
              />
            </Card>
          </Grid>

          {graphs?.map((graph) => {
            return (
              <ImgGraph
                key={graph.id}
                graphData={graph}
              />
            )
          })}
        </Grid>
      </MDBox>

    </DashboardLayout>
  );
}

export default Charts;
